module.exports = __webpack_public_path__ + "media/npc_dota_hero_venomancer.d10e5805.webm";